import { supabase } from "@/lib/supabase/supabaseClient";
import { AddQuestionProps } from ".";

export const addQuestionWithQuestionBankIfNeeded = async (
  props: AddQuestionProps
) => {
  if (!props.survey_id) throw new Error("Missing Survey ID");
  let question_bank_ref_id = props.question_bank_ref_id || props.id || null;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    survey_id,
    id,
    organisation_id,
    selected_configuration,
    question_bank_ref_id: _question_bank_ref_id,
    survey_bank_question_bank_ref_id,
    created_at,
    ...body
  } = props;
  const field_type_context_stack = [
    ...(body.field_type_context_stack || []),
    {
      crm_system: body.crm_system,
      field_type: body.field_type,
    },
  ];
  if (!question_bank_ref_id) {
    const data = await supabase
      .from("question_bank")
      .insert({
        ...body,
        organisation_id,
        selected_configuration: {
          parameter: selected_configuration?.parameter,
          conditionals: {
            enabled: false,
            where: {
              or: [{ and: [] }],
            },
          },
        },
        field_type_context_stack,
      })
      .select()
      .maybeSingle()
      .throwOnError()
      .then(res => res.data);
    question_bank_ref_id = data?.id;
  }
  return await supabase
    .from("question")
    .insert({
      ...body,
      survey_id,
      question_bank_ref_id,
      selected_configuration,
      field_type_context_stack,
      survey_bank_question_bank_ref_id,
    })
    .select()
    .maybeSingle()
    .throwOnError()
    .then(res => res.data);
};
